import React from 'react'
import styled from 'styled-components'
import { breakpoints } from '../../core/application/theme/breakpoints'
import { GeoPositionIcon, MinusIcon, PlusIcon } from '../icons'
import Loader from './Loader'

export interface IMapControllersProps {
  currentZoom: number
  maxZoom: number
  minZoom: number
  isGeolocationLoading: boolean
  increaseZoom: () => void
  decreaseZoom: () => void
  geolocation?: () => void
}

const MapControllers: React.FC<IMapControllersProps> = ({
  currentZoom,
  maxZoom,
  minZoom,
  isGeolocationLoading,
  increaseZoom,
  decreaseZoom,
  geolocation
}) => {
  return (
    <Container data-testid="mapControllers-container">
      {geolocation && (
        <Controller
          disabled={isGeolocationLoading}
          className="geolocation"
          data-testid="geolocation-button"
          onClick={() => geolocation()}
        >
          {isGeolocationLoading ? <Loader /> : <GeoPositionIcon />}
        </Controller>
      )}
      <Controller disabled={currentZoom >= maxZoom} data-testid="increase-zoom-button" onClick={() => increaseZoom()}>
        <PlusIcon />
      </Controller>
      <Controller disabled={currentZoom <= minZoom} data-testid="decrease-zoom-button" onClick={() => decreaseZoom()}>
        <MinusIcon />
      </Controller>
    </Container>
  )
}

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  margin-top: 14px;

  & > button.geolocation {
    margin-bottom: 16px;
  }

  & > button {
    margin-bottom: 8px;
  }

  @media ${breakpoints.tablet} {
    justify-content: center;
    margin-top: unset;
  }
`

const Controller = styled.button`
  background-color: ${({ theme }) => theme.color.primary};
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg {
    path {
      fill: ${({ theme }) => theme.color.secondary};
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.color.darkGrey};
  }

  transition: all 300ms ease-out;
`

export default MapControllers
